import { render } from "./Create75Liquidation2.vue?vue&type=template&id=7195d5c0"
import script from "./Create75Liquidation2.vue?vue&type=script&lang=js"
export * from "./Create75Liquidation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__